import React from 'react';
import {
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography
} from '@material-ui/core';
import { Event } from '@material-ui/icons';
import { Filters } from './../services/Filters';

const _filters = new Filters();

export const EventItem = (props) => {

  const {
    item: {
      id,
      url,
      header,
      start_ts,
      end_ts
    },
    itemCategory,
    onClick
  } = props;

  return (
    <ListItem
      divider
      button
      onClick={(e) => onClick(e, url, id)}
    >
      <ListItemIcon><Event /></ListItemIcon>
      <ListItemText>
        {header}
        <Typography
          variant='caption'
        >
          {itemCategory ? <span>{itemCategory.CALENDAR_TITLE}: </span> : null}
          {_filters.startEndDate(start_ts, end_ts)}
        </Typography>
      </ListItemText>
    </ListItem>
  )

}


// WEBPACK FOOTER //
// ./src/components/EventItem.js